﻿import { Decorators } from "@serenity-is/corelib";

export enum DocumentSource {
    Cemdo = 0,
    Agorum = 1
}
Decorators.registerEnumType(DocumentSource, 'Cemdo.Default.Documents.DocumentSource');